import styled from 'styled-components';

const LeftNavMain = styled.div`
  width: 13%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-image: url('https://res.cloudinary.com/dojodevs/image/upload/v1574746789/smartia/RECURSOS/STOCK_HAL_07_drydod.jpg');
  background-size:     cover;
  background-repeat:   no-repeat;
  background-position: center center;
  left: 0;
  top: 0;
  position: fixed;
`;

const LeftNavFloat = styled.div`
  /* width: 100%; */
  height: 75%;
  margin-top: 10%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  text-decoration: none;
  /* margin: 20px; */
  /* padding: 20px; */
  font-size: 20px;
  position: fixed;
`;

const LeftNavLink = styled.a`
  color: white;
  cursor: pointer;
  text-decoration: none;
  margin: 20px;
  /* padding: 20px; */
  font-size: 22px;
`;


export { LeftNavMain, LeftNavFloat, LeftNavLink };